import { useCallback } from "react";

const DOWNLOAD_FILENAME = "shoe.png";

export const useDownloadCanvas = () => {
  return useCallback(() => {
    const link = document.createElement("a");
    link.setAttribute("download", DOWNLOAD_FILENAME);
    link.setAttribute("href", document.querySelector("canvas").toDataURL("image/png").replace("image/png", "image/octet-stream"));
    link.click();
  }, []);
};
